import React from 'react';
import {Box, Grid} from '@mui/material';
import aboutUs from '../assets/about_photo.png';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

export const AboutUs = () => {
	return (
		<Container maxWidth="lg">
			<div id={'mainPanel'}/>
			<Grid container spacing={5} paddingTop={5} paddingBottom={4} alignItems="center">
				<Grid item xs={0} md={5} sx={{display: {xs: 'none', md: 'flex'}}}>
					<Box component="img" src={aboutUs} alt="About Us"
					     sx={{width: '100%', height: 'auto', objectFit: 'contain', borderRadius: 3}}/>
				</Grid>
				<Grid item xs={12} md={7}>
					<Typography component="h2" sx={{
						fontWeight: 800,
						color: '#58595b',
						fontSize: {xs: '1.6rem', md: '2rem'},
						letterSpacing: '0.02em',
					}}>
						ABOUT US
					</Typography>
					<Box sx={{width: '64px', height: '4px', backgroundColor: 'primary.main', borderRadius: 2, marginTop: 1, marginBottom: 3}}/>
					<Typography sx={{lineHeight: 1.8}}>
						Hop Soft Pty Ltd is one of the leading software developers in the automation industry.
						We develop a wide variety of drivers, plugins, modules and apps. Our aim is to deliver
						feature rich, affordable, documented and well tested products. All our developers are
						industry experts with more than 10 years of experience in the field. We offer a variety
						of services such as contract work for manufacturers, co-funded contracts for integrators
						and also complete projects funded by us.
					</Typography>
				</Grid>
			</Grid>
		</Container>
	);
};
